import { QNAS } from '@/consts/qnas';
import { getLanguage } from '@/utils/localStorageControl';
import { Container, Accordion } from '@mantine/core';

export default function Faq() {
  const lang = getLanguage();
  // Use 'ko' as fallback if the language is not available in QNAS
  const safeLanguage = (lang in QNAS) ? lang : 'en';
  
  return (
    <Container id={'qna'} className='w-full pb-[40px]'>
      <div className='text-center uppercase font-semibold text-base text-gray-500 dark:text-gray-400'>자주 물어보는 질문</div>
      <div className='text-center text-2xl md:text-3xl font-bold text-gray-700 dark:text-gray-100 mb-10 mt-2'>QnA</div>
      <div className='p-4' data-aos="fade-up" data-aos-delay="250" data-aos-duration="300">
        <Accordion variant={"separated"}>
          { QNAS[safeLanguage as keyof typeof QNAS].map((item, index) => (
            <Accordion.Item key={index} className='rounded-lg mb-4 border-1 border-gray-200 dark:border-gray-700 dark:bg-gray-800' value={item.question}>
              <Accordion.Control classNames={{ label: 'text-sm md:text-base' }}>{item.question}</Accordion.Control>
              <Accordion.Panel className='text-sm md:text-base leading-6'>{item.answer.split('\n').map(i => <div key={i}>{i}</div>)}</Accordion.Panel>
            </Accordion.Item>
          ))}
          </Accordion>
      </div>
    </Container>
  );
}